export default class Sticker {
    constructor(props) {
        this.toPixels = 3.7795275591;
        this.props = {
            font_family: null,
            background: null,
            text_color: null,
            image: null,
            model: null,
            first_name: null,
            last_name: null,
            image_border: null,
            data_only: null,
        }

        this.data = {
            sizes: {
                single: null,
                multiple: null,
            },
            text_coordinates: null,
            image_coordinates: null,
            image_sizes: null,
            font_size: null,
            full_name: null
        }
    }

    getSizes() {
        return this.data.sizes;
    }

    getDecorSizes() {
        return {
            x: (this.data.sizes.x / 10) + ' cm',
            y: (this.data.sizes.y / 10) + ' cm',
        }
    }

    getTextCoordinates() {
        return this.data.text_coordinates;
    }

    getImageCoordinates() {
        return this.data.image_coordinates;
    }

    getImageSizes() {
        return this.data.image_sizes;
    }

    getFontSize() {
        return this.data.font_size;
    }

    getFont() {
        return this.props.font_family;
    }

    getBg() {
        return this.props.background;
    }

    getTextColor() {
        return this.props.text_color;
    }

    getImg() {
        return this.props.image;
    }

    getFirstName() {
        return this.props.first_name;
    }

    getLastName() {
        return this.props.last_name;
    }

    getFullName() {
        let fullName = '';

        if(this.props.first_name && this.props.last_name) {
            fullName = this.props.first_name + ' ' + this.props.last_name;
        }else if(this.props.first_name) {
            fullName = this.props.first_name;
        }else {
            fullName = this.props.last_name;
        }

        return fullName;
    }

    getAll() {
        return {
            props: this.props,
            data: this.data
        };
    }

    convertToPixels(value) {
        let result = value * this.toPixels;

        return parseInt(result.toString());
    }
}
